/*
Tar bort tomma p-element på sajten.
*/

const paragraphs = document.getElementsByTagName("p");
for (let i = 0, len = paragraphs.length; i < len; i += 1) {
	const elem = paragraphs[i];
	if (elem.childElementCount === 0 && elem.textContent.trim() === "") {
		elem.parentNode.removeChild(elem);
		i -= 1;
		len -= 1;
	}
}

// TODO: Fixa en funktion som tar bort alla &nbsp; från alla element.

// (function($) {
//   $(document).ready(function() {
//     const str = $('.number').html();
//     str.replace('&nbsp;', '');
//     $('.number').html(str);
//   });
// })(jQuery);
